// Church Spotlight / Featured Announcement
// Change this data to update what's featured on the home page.
// Types: 'feast' | 'fast' | 'holy-week' | 'event' | 'choir' | 'announcement'

export type SpotlightType = 'feast' | 'fast' | 'holy-week' | 'event' | 'choir' | 'announcement';

export interface SpotlightData {
  active: boolean;
  type: SpotlightType;
  badge: string;
  title: string;
  subtitle?: string;
  description: string;
  dateRange?: string;
  image: string;
  imageAlt: string;
  ctaLabel?: string;
  ctaLink?: string;
  accentColor: string;
}

export interface SecondaryAnnouncementData {
  active: boolean;
  type: SpotlightType;
  badge: string;
  title: string;
  description: string;
  dateRange?: string;
  time?: string;
  image: string;
  imageAlt: string;
  ctaLabel?: string;
  ctaLink?: string;
}

export const spotlight: SpotlightData = {
  active: false,
  type: 'feast',
  badge: 'Feast of Pentecost',
  title: 'The Joyful Season of Pentecost',
  subtitle: '\u2cac\u0300\u2ca3\u2c93\u2ca5\u2ca7\u2c9f\u2ca5 \u2c80\u0300\u2c9b\u2c89\u2ca5\u2ca7\u2c8f \u2014 Christ is Risen!',
  description:
    'We are living in the most sacred season of the Coptic Orthodox year \u2014 the Holy Fifty Days (\u2ca0\u2c93\u2c99\u2c8f\u03e3 \u2c9b\u0300\u2ca3\u2c9f\u2c99\u2ca1\u2c93), stretching from the Glorious Resurrection of our Lord Jesus Christ to the Feast of Pentecost. In the Coptic tradition, these fifty days are treated as one continuous Sunday \u2014 kneeling in prayer is forbidden, fasting is completely lifted, and every Divine Liturgy opens with the joyful proclamation \u2cac\u0300\u2ca3\u2c93\u2ca5\u2ca7\u2c9f\u2ca5 \u2c80\u0300\u2c9b\u2c89\u2ca5\u2ca7\u2c8f \u2014 \u2c80\u0300\u2c97\u2c8f\u2c91\u2cb1\u2ca5 \u2c80\u0300\u2c9b\u2c89\u2ca5\u2ca7\u2c8f (Christ is Risen \u2014 Truly He is Risen). The Alleluia, silenced throughout Great Lent, returns in full voice. This is the triumph of life over death, of light over darkness. Come, rejoice with us.',
  dateRange: 'June 8, 2026',
  image: '/assets/readdy/676a77a0bf45cf4736e9e894849d1e33-c94455ef0341.jpeg',
  imageAlt: 'The Holy 50 Days \u2014 Pentecost Season',
  ctaLabel: 'Read More on News',
  ctaLink: '/news?article=holy-fifty-days-2026',
  accentColor: 'gold',
};

// \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
// Secondary announcements \u2014 each active item becomes an additional slide in
// the spotlight carousel on the home page.
//
// HOW TO ADD AN EVENT:
//   1. Copy the template below into the array
//   2. Fill in the details
//   3. Set  active: true
//   4. Save \u2014 it will appear automatically as a new slide
//
// Template:
// {
//   active: true,
//   type: 'event',                  // feast | fast | holy-week | event | choir | announcement
//   badge: 'Event',                 // Short label shown on the badge
//   title: 'Your Event Title',
//   description: 'Describe the event here.',
//   dateRange: 'Month Day, Year',
//   time: '10:00 AM',               // Optional
//   image: '/assets/readdy/hero-church-interior-001-efa98afb613e.jpg',
//   imageAlt: 'Event image description',
//   ctaLabel: 'Read More',
//   ctaLink: '/news',
// },
// \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
export const secondaryAnnouncements: SecondaryAnnouncementData[] = [];
